// components/ExcelDownloadButton.jsx
import React from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const ExcelDownload = ({ data, fileName = "Export.xlsx", sheetName = "Sheet1" }) => {
  const exportToExcel = () => {
    if (!data || data.length === 0) {
      alert("No data available to export");
      return;
    }

    // Convert JSON to worksheet
    const worksheet = XLSX.utils.json_to_sheet(data);

    // Create workbook and append worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

    // Generate Excel buffer
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });

    saveAs(blob, fileName);
  };

  return (
    <button className="btn btn-success" onClick={exportToExcel}>
      Download Excel
    </button>
  );
};

export default ExcelDownload;